import { render } from "./YouTubeCustom.vue?vue&type=template&id=2bea1798"
import script from "./YouTubeCustom.vue?vue&type=script&lang=js"
export * from "./YouTubeCustom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/malum/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__